module.exports = "pegasus/assets/theme4/arrow.png";